document.addEventListener('DOMContentLoaded', function () {
  var tocList = document.querySelector(
    '#ruffruff-table-of-contents ol'
  );

  if (!tocList) return;

  var tocItems = document.querySelectorAll(
    '#ruffruff-table-of-contents .ruffruff-table-of-contents-list-item'
  );

  if (!tocItems.length) return;

  var oldBtn = document.querySelector('#toc-toggle-btn');

  if (oldBtn) {
    oldBtn.remove();
  }

  if (tocItems.length <= 4) return;

  tocItems.forEach(function (item, index) {
    if (index > 3) {
      item.style.setProperty(
        'display',
        'none',
        'important'
      );
    }
  });

  var btn = document.createElement('button');

  btn.id = 'toc-toggle-btn';
  btn.type = 'button';
  btn.textContent = 'See More +';
  btn.setAttribute('aria-expanded', 'false');

  tocList.after(btn);

  btn.addEventListener('click', function (event) {
    event.preventDefault();

    var scrollTop = window.pageYOffset;
    var isExpanded =
      btn.getAttribute('aria-expanded') === 'true';

    tocItems.forEach(function (item, index) {
      if (index > 3) {
        item.style.setProperty(
          'display',
          isExpanded ? 'none' : 'list-item',
          'important'
        );
      }
    });

    btn.setAttribute(
      'aria-expanded',
      isExpanded ? 'false' : 'true'
    );

    btn.textContent =
      isExpanded ? 'See More +' : 'See Less −';

    window.scrollTo({
      top: scrollTop,
      behavior: 'auto'
    });
  });
});